export default {
  bases: ['/orders', '/order'],
  fetches: [],
  build: () => []
}
